export enum TranslationLanguageEnum {
    none = 0,
    ru = 1,
    kz = 2,
    en = 3,
    kg = 4,
    fr = 5,
    ja = 6,
    zh = 7,
  }